import { SparkleFilled, SparkleRegular } from "@fluentui/react-icons";
import styles from "./Example.module.css";

interface Props {
    text: string;
    value: string;
    onClick: (value: string) => void;
}

export const Example = ({ text, value, onClick }: Props) => {
    return (
        <div className={styles.example} onClick={() => onClick(value)}>
            <SparkleRegular fontSize={"30px"} primaryFill={"rgb(248,165,69)"} aria-hidden="true" aria-label="sparkle-ai-icon" style={{ marginBottom:'5px' }}/> 
            <p className={styles.exampleText}>{text}</p>
        </div>
    );
};
